import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SettingsContext = createContext(null);

const DEFAULT_SETTINGS = {
  business_name: "Pick Auto Sales",
  tagline: "Sales · Madison, TN",
  address_line1: "1484 Gallatin Pike N",
  address_line2: "Madison, TN 37115",
  city_region: "Madison, TN · Metro Nashville",
  phone: "(615) 574-3007",
  email: "hello@pickautosales.com",
  hours_weekday: "Mon – Sat · 9AM – 6PM",
  hours_sunday: "Sunday · Closed",
  hours_short: "9AM – 6PM Mon–Sat",
  rating: "4.6★",
  google_maps_url: "https://maps.google.com/?q=1484+Gallatin+Pike+N,+Madison,+TN+37115",
  latitude: 36.2557,
  longitude: -86.7106,
  map_embed_src: null,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {
      /* keep defaults */
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, loaded, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext) || { settings: DEFAULT_SETTINGS, loaded: true };
